var id_array = [];
function editSection(section_id){
    id_array = [];
    var section = data_object['sections'][section_id];
    var section_name = section['section_name'];
    var section_type = section['section_type'] == 'shops'? 'Магазины':
        section['section_type'] == 'stocks'? 'Акции':
            section['section_type'] == 'banners'? 'Рекламные баннеры':
                section['section_type'] == 'products'? 'Продукты':
                    section['section_type'] == 'categories'? 'Категории':
                        'Ошибка';
    var section_items = section['section_items'];
    var section_items_html = '';
    $.each(section_items, function(index, item){
        var item_id = index;
        var item_name = item['item_name'];
        var item_img = item['item_img'];
        var stock_discount = item['stock_discount']==undefined?'':item['stock_discount'];
        var item_img = item['item_img']==undefined?'':'<img src="'+item['item_img']+'" alt="">';
        var item_href = item['item_href'];
        id_array.push(+item_id);
        section_items_html += '\
        <div class="col-xs-12 col-sm-6">\
            <div class="feed-item thumbnail clearfix" data-element-id="'+item_id+'">\
                '+item_img+'<a href="'+item_href+'" target="_blank">'+item_name+'</a>\
                <div class="remove-btn glyphicon glyphicon-remove" onclick="removeElement($(this))"></div>\
                <div class="discount">'+stock_discount+'</div>\
            </div>\
        </div>\
        ';
    });
    var final_HTML = '\
        <div class="modal fade" id="edit-block-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">\
            <div class="modal-dialog" role="document">\
                <div class="modal-content">\
                    <form id="formx_edit" class="form-horizontal" role="form" method="POST" action="#">\
                        <div class="modal-header">\
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\
                            <h4 class="modal-title" id="myModalLabel">Редактирование блока</h4>\
                        </div>\
                        <div class="modal-body">\
                            <div class="form-group">\
                                <label for="sectionName" class="col-md-4 control-label">Название блока</label>\
                                <div class="col-md-6">\
                                    <input id="sectionName" type="text" class="form-control" name="sectionName" value="'+section_name+'" required="" autofocus="">\
                                </div>\
                            </div>\
                            <div class="form-group">\
                                <label for="type" class="col-md-4 control-label">Тип блока</label>\
                                <div class="col-md-6">\
                                    <p>'+section_type+'</p>\
                                </div>\
                            </div>\
                            <div id="currentItems" class="items-block clearfix">'+section_items_html+'</div>\
                            <hr>\
                            <div id="searchItemsContainer">\
                                <div class="form-group">\
                                    <label for="name" class="col-sm-4 control-label">Поиск</label>\
                                    <div class="col-sm-6">\
                                        <input type="text" class="form-control" id="searchInput" placeholder="Введите название" autocomplete="false">\
                                    </div>\
                                </div>\
                                <div class="search-results">\
                                </div>\
                            </div>\
                        </div>\
                        <div class="modal-footer">\
                            <button type="button" id="delete-btn" class="btn btn-danger pull-left" onclick="removeSection('+section_id+')">\
                                Удалить блок\
                            </button>\
                            <button type="button" class="btn btn-default" data-dismiss="modal">Отмена</button>\
                            <button type="button" class="btn btn-primary btn-submit">Сохранить</button>\
                        </div>\
                    </form>\
                </div>\
            </div>\
        </div>\
        ';
    $('#modal-container').append(final_HTML);
    var modalContainer = $('#edit-block-modal');

    modalContainer.modal();
    //Самоуничтожение при закрытии модалки
    modalContainer.on('hidden.bs.modal', function () {
        $('#modal-container').html('');
    });

    $('#formx_edit .btn-submit').on ('click', function (event) {
        xsubmit_edit(section_id);
    });
    $('#searchInput').on('change input paste',function(){
        var _this = $(this);
        if (_this.val().length > 0) {
            section['section_type'] == 'shops'? searchShops(_this.val()):
                section['section_type'] == 'stocks'? searchStocks(_this.val()):
                    section['section_type'] == 'banners'? searchBanners(_this.val()):
                        section['section_type'] == 'products'? searchProducts(_this.val()):
                            section['section_type'] == 'categories'? searchCategories(_this.val()):
                                bsAlert('Ошибка', 'Что-то пошло не так', 'danger');
        } else {
            $('.search-results').html("");
        }
    });
}
function createSection(){
    id_array = [];
    var final_HTML = '\
    <div class="modal fade" id="edit-block-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">\
        <div class="modal-dialog" role="document">\
            <div class="modal-content">\
                <form id="formx_create" class="form-horizontal" role="form" method="POST">\
                    <div class="modal-header">\
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\
                        <h4 class="modal-title" id="myModalLabel">Создание блока новостей</h4>\
                    </div>\
                    <div class="modal-body">\
                        <div class="form-group">\
                            <label for="sectionName" class="col-md-4 control-label label-required">Название блока</label>\
                            <div class="col-md-6">\
                            <input id="sectionName" type="text" class="form-control" name="sectionName" value="" required="" autofocus="">\
                            </div>\
                        </div>\
                        <div class="form-group">\
                            <label for="type" class="col-md-4 control-label label-required  ">Тип блока</label>\
                            <div class="col-md-6">\
                            <select name="type" class="form-control" id="type">\
                            <option value="products" selected>Товары</option>\
                            <option value="stocks">Акции</option>\
                            <option value="shops">Магазины</option>\
                            <option value="banners">Баннеры</option>\
                            <option value="categories">Категории</option>\
                            </select>\
                            </div>\
                        </div>\
                        <div id="currentItems" class="items-block clearfix">\
                        \
                        </div>\
                        <hr>\
                        <div id="searchItemsContainer">\
                            <div class="form-group">\
                                <label for="name" class="col-sm-4 control-label">Поиск</label>\
                                <div class="col-sm-6">\
                                    <input type="text" class="form-control" id="searchInput" placeholder="Введите название" autocomplete="false">\
                                </div>\
                            </div>\
                            <div class="search-results">\
                            \
                            </div>\
                        </div>\
                    </div>\
                    <div class="modal-footer">\
                        <button type="button" class="btn btn-default" data-dismiss="modal">Отмена</button>\
                        <button type="button" class="btn btn-primary btn-submit">Сохранить</button>\
                    </div>\
                </form>\
            </div>\
        </div>\
    </div>\
        ';
    $('#modal-container').append(final_HTML);
    var modalContainer = $('#edit-block-modal');

    modalContainer.modal();
    //Самоуничтожение при закрытии модалки
    modalContainer.on('hidden.bs.modal', function () {
        $('#modal-container').html('');
    });

    $('#formx_create .btn-submit').on ('click', function (event) {
        xsubmit_create()
    });
    $('select#type').on('change', function () {
        $('#searchInput').val('');
        id_array = [];
        $('#currentItems').html("");
        $('.search-results').html("");
    });
    $('#searchInput').on('change input paste',function(){
        var _this = $(this);
        if (_this.val().length > 0) {
            switch ($('select#type').val()) {
                case "stocks":
                    searchStocks(_this.val());
                    break;
                case "shops":
                    searchShops(_this.val());
                    break;
                case "products":
                    searchProducts(_this.val());
                    break;
                case "banners":
                    searchBanners(_this.val());
                    break;
                case "categories":
                    searchCategories(_this.val());
                    break;
                default :
                    break;
            }
        } else {
            $('.search-results').html("");
        }
    });
}

function addElement(_this) {
    var id = _this.parent().data("element-id");
    //Если элемент, который мы добавляем отсутствует в списке уже добавленных, копируем внутренности этого элемента в область добавленных
    if ($('.items-block [data-element-id=' + id + ']')[0] == undefined) {
        $('.items-block').append('<div class="col-xs-12 col-sm-6">'
            + _this.parent()[0].outerHTML
            + '</div>');

        //Удаляем кнопку "+"
        $('.items-block [data-element-id=' + id + '] .add-btn').detach();

        //Добавляюем кнопку "х"(удалить)
        $('.items-block [data-element-id=' + id + ']').append('<div class="remove-btn" onclick="removeElement($(this))"><span class="glyphicon glyphicon-remove"></span></div>');
        id_array.push(id);
    }
}
function removeElement(_this) {
    var id = +_this.parent().data("element-id");
    _this.parent().parent().detach();

    console.log(id_array);
    console.log(id);
    console.log(id_array.indexOf(id));

    var a = id_array.splice(id_array.indexOf(id),1);

    console.log("id_array: "+id_array);
    console.log("deleted: "+a)
}
